var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { creditCard, deposit, getOutages, invest, mortgage, auto, } from '@ally/data-selectors-afg-accounts';
import { bankOnlyTransfers, investTransfers, combinedTransfers, getPaymentsDropdownItems, WealthOverviewLink, investmentsLink, deposits, getManageCDsItem, getManageIRAsItem, bankStatements, investDocuments, taxForms, homeLoansStatementsButton, documentDropdown, homeLoansButton, vehiclePaymentsLink, bankTaxForms, vehicleDocuments, investStatements, statementDropdown, bankDocuments, creditCardLink, ccStatements, directDeposit, checkDeposits, } from './items';
export var filterExpiredAccount = function (_a) {
    var closeDate = _a.closeDate;
    if (!closeDate) {
        return true;
    }
    var today = new Date();
    var dayDifference = today.getDate() - 60;
    var unixSixtyDaysAgo = today.setDate(dayDifference);
    var sixtyDaysAgo = new Date(unixSixtyDaysAgo).getTime();
    var isMoreThan60 = new Date(closeDate).getTime() < sixtyDaysAgo;
    return !isMoreThan60;
};
var filterOpenDepositAccounts = function (_a) {
    var closeDate = _a.closeDate;
    return !closeDate;
};
export var useSchemaItems = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var hostServices = _a.hostServices;
    var hostData = hostServices.hostData, featureFlags = hostServices.featureFlags, session = hostServices.session, redirectToMortgage = hostServices.redirectToMortgage;
    var wealth = (_d = (_c = (_b = session === null || session === void 0 ? void 0 : session.data) === null || _b === void 0 ? void 0 : _b.relationships) === null || _c === void 0 ? void 0 : _c.invest) === null || _d === void 0 ? void 0 : _d.wealth;
    var isWealthEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_wealth-management', false);
    var isWealthProspect = (wealth === null || wealth === void 0 ? void 0 : wealth.indicator) === 'YES' &&
        (wealth === null || wealth === void 0 ? void 0 : wealth.status) === 'PROSPECT' &&
        isWealthEnabled;
    var isWealthClient = (wealth === null || wealth === void 0 ? void 0 : wealth.indicator) === 'YES' &&
        ((wealth === null || wealth === void 0 ? void 0 : wealth.status) === 'CLIENT_UNFUNDED' ||
            (wealth === null || wealth === void 0 ? void 0 : wealth.status) === 'CLIENT_FUNDED') &&
        isWealthEnabled;
    var isBankDown = getOutages(hostData).DEPOSIT === 'full';
    var isInvestDown = getOutages(hostData).INVEST === 'full';
    var isWealthDown = isWealthEnabled && getOutages(hostData).WEALTH === 'full';
    var allyUserRole = ((_e = session.data) === null || _e === void 0 ? void 0 : _e.allyUserRole) || {};
    var isInvestUser = allyUserRole.investment, isAutoUser = allyUserRole.auto;
    var allDepositAccounts = (_f = deposit
        .getAll(hostData)) === null || _f === void 0 ? void 0 : _f.filter(filterExpiredAccount);
    var allInvestAccounts = invest.getAll(hostData);
    var allOpenDepositAccounts = (_g = deposit
        .getAll(hostData)) === null || _g === void 0 ? void 0 : _g.filter(filterOpenDepositAccounts);
    var hasOpenDepositAccounts = !!(allOpenDepositAccounts === null || allOpenDepositAccounts === void 0 ? void 0 : allOpenDepositAccounts.length); // Open = no closed accounts
    var hasActiveDepositAccounts = !!(allDepositAccounts === null || allDepositAccounts === void 0 ? void 0 : allDepositAccounts.length); // Active = open accounts and accounts closed within 60 days
    var hasInvestAccounts = !!(allInvestAccounts === null || allInvestAccounts === void 0 ? void 0 : allInvestAccounts.length);
    var hasBankOrInvestAccounts = hasOpenDepositAccounts || hasInvestAccounts;
    var isOpenBankUserNotInvest = hasOpenDepositAccounts && !isInvestUser && !isWealthClient;
    var isInvestNotBank = isInvestUser && !hasOpenDepositAccounts;
    var isInvestUserWithOpenDepositAccounts = hasOpenDepositAccounts && isInvestUser;
    var taxFormsEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_tax-forms-link-in-subnav', true);
    var isInvestAndWealthClient = isInvestUser && isWealthClient && !hasOpenDepositAccounts;
    var isBankAndWealthClient = hasOpenDepositAccounts && isWealthClient && !isInvestUser;
    var isBankInvestAndWealthClient = hasOpenDepositAccounts && isWealthClient && isInvestUser;
    var hasCDAnonIRA = deposit.nonRetirement.getByType('CDA')(hostData).length > 0;
    var hasOnlyIRA = (_h = allDepositAccounts === null || allDepositAccounts === void 0 ? void 0 : allDepositAccounts.every) === null || _h === void 0 ? void 0 : _h.call(allDepositAccounts, function (depositAccount) {
        var _a, _b;
        return (_b = (_a = depositAccount.indicator) === null || _a === void 0 ? void 0 : _a.retirement) !== null && _b !== void 0 ? _b : false;
    });
    var hasOnlyCDorIRA = (_j = allDepositAccounts === null || allDepositAccounts === void 0 ? void 0 : allDepositAccounts.every) === null || _j === void 0 ? void 0 : _j.call(allDepositAccounts, function (depositAccount) {
        var _a, _b;
        return (depositAccount.type === 'CDA' ||
            ((_b = (_a = depositAccount.indicator) === null || _a === void 0 ? void 0 : _a.retirement) !== null && _b !== void 0 ? _b : false));
    });
    var hasIRA = deposit.retirement.getAll(hostData).length > 0;
    var isCdIraHiddenInMobile = !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('ff_mobile-manage-cd-ira', false));
    var showBankPayments = hasOpenDepositAccounts &&
        deposit.nonRetirement
            .getAll(hostData)
            .some(function (_a) {
            var type = _a.type;
            return type !== 'CDA';
        }); // Has some non-retirement account other than CD
    var isWiresHiddenInMobile = !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_mobile-wires', false));
    var isNewPaymentsNavEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_payments-new-nav', false);
    var isAllyUserRoleCC = allyUserRole === null || allyUserRole === void 0 ? void 0 : allyUserRole.creditcard;
    var isCCEnabled = featureFlags.variation('FF_credit-card-snapshot');
    var hasCCAccounts = creditCard.getAll(hostData).length > 0;
    var restrictedStatuses = ['BANKRUPT', 'STOLEN', 'LOST', 'FROZEN_OR_FRAUD'];
    var allRestrictedCCAccounts = creditCard
        .getAll(hostData)
        .map(function (account) { return account.status; })
        .every(function (status) { return restrictedStatuses.includes(status); });
    var showCreditCard = isCCEnabled && isAllyUserRoleCC && hasCCAccounts && !allRestrictedCCAccounts;
    var isAllyUserRoleMortgage = allyUserRole === null || allyUserRole === void 0 ? void 0 : allyUserRole.mortgage;
    var isMortgageEnabled = featureFlags.variation('FF_mortgage-nga', false);
    var hasMortgageAccounts = mortgage.getAll(hostData).length > 0;
    var hasBlockedMortgageAccounts = mortgage.hasBlockedAccounts(hostData);
    var showMortgageLink = isMortgageEnabled &&
        isAllyUserRoleMortgage &&
        hasMortgageAccounts &&
        !hasBlockedMortgageAccounts;
    var isAutoEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_SPOG_WEB_UI', false);
    var hasAutoAccounts = auto.getAll(hostData).length > 0;
    var showAuto = isAutoEnabled && isAutoUser;
    // We will pass the ID for the first account from the Accounts call
    // when there is more than one account
    var firstAutoAccount = auto.getAll(hostData)[0];
    var isCCOnly = showCreditCard &&
        !hasOpenDepositAccounts &&
        !isInvestUser &&
        !isWealthClient &&
        !showAuto &&
        !showMortgageLink;
    var isMortgageOnly = !hasOpenDepositAccounts &&
        !isInvestUser &&
        !isWealthClient &&
        !showAuto &&
        !showCreditCard &&
        showMortgageLink;
    var isAutoOnly = !hasOpenDepositAccounts &&
        !isInvestUser &&
        !isWealthClient &&
        !showMortgageLink &&
        !showCreditCard &&
        showAuto;
    // bank transfers should not show for closed accounts, for a invest and bank user with a closed bank account they should get the invest only experience
    var getTransfers = function () {
        // This could be a link or dropdown based on the isNewPaymentsNavEnabled FF
        var BankTransferMenu = hasOnlyIRA
            ? []
            : [bankOnlyTransfers(isNewPaymentsNavEnabled, isWiresHiddenInMobile)];
        var InvestTransferLink = [investTransfers()];
        var TransferDropdown = hasOnlyIRA
            ? [investTransfers()]
            : [combinedTransfers(isNewPaymentsNavEnabled, isWiresHiddenInMobile)];
        if (isOpenBankUserNotInvest) {
            return isBankDown ? [] : BankTransferMenu;
        }
        if (isInvestNotBank || isInvestAndWealthClient) {
            return isInvestDown ? [] : InvestTransferLink;
        }
        if (isInvestUserWithOpenDepositAccounts ||
            isBankAndWealthClient ||
            isBankInvestAndWealthClient) {
            if (isBankDown)
                return InvestTransferLink;
            if (isInvestDown)
                return BankTransferMenu;
            return TransferDropdown;
        }
        return [];
    };
    // payments dropdown should only be shown on open Checking and/or savings accounts and non-blocked mortgage accounts
    var getPayments = function () {
        if (!showMortgageLink &&
            !showBankPayments &&
            !showAuto &&
            !showCreditCard) {
            return [];
        }
        var paymentsDropdown = {
            type: 'menu',
            triggerContent: 'Payments',
            items: [],
            key: 'payments',
        };
        if (isCCOnly) {
            paymentsDropdown.items.push(creditCardLink);
            return [paymentsDropdown];
        }
        if (isMortgageOnly) {
            paymentsDropdown.items.push(homeLoansButton(redirectToMortgage));
            return [paymentsDropdown];
        }
        if (isAutoOnly) {
            paymentsDropdown.items.push(vehiclePaymentsLink);
            return [paymentsDropdown];
        }
        if (showBankPayments) {
            paymentsDropdown.items = getPaymentsDropdownItems(isNewPaymentsNavEnabled, isWiresHiddenInMobile);
        }
        if (showCreditCard) {
            paymentsDropdown.items.push(creditCardLink);
        }
        if (showMortgageLink) {
            paymentsDropdown.items.push(homeLoansButton(redirectToMortgage));
        }
        if (showAuto) {
            paymentsDropdown.items.push(vehiclePaymentsLink);
        }
        return [paymentsDropdown];
    };
    var getWealthOverview = function () {
        if (isWealthProspect || isWealthClient) {
            return [WealthOverviewLink];
        }
        return [];
    };
    var getInvestments = function () {
        if (isInvestUser) {
            return isInvestDown ? [] : [investmentsLink];
        }
        return [];
    };
    var isDirectDepositEnabled = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.variation('FF_direct-deposit-switch', false);
    // deposits should only show for active (not closed) accounts
    var getDeposits = function () {
        var depositsDropdown = {
            type: 'menu',
            triggerContent: 'Deposits',
            items: [checkDeposits, directDeposit],
            key: 'depositsDropdown',
        };
        var directDepositEnabledContent = function () {
            // if user has only IRA accounts we should not display anything in the subnav
            if (hasOnlyIRA)
                return [];
            // if user has only CD or IRA accounts, we should only display check deposits link in subnav
            if (hasOnlyCDorIRA)
                return [deposits];
            // if user has SDA, DDA or MMA accounts, we should display deposits dropdown including DDX and check deposits links
            return [depositsDropdown];
        };
        if (isDirectDepositEnabled && hasOpenDepositAccounts) {
            return directDepositEnabledContent();
        }
        if (hasOpenDepositAccounts) {
            return hasOnlyIRA ? [] : [deposits];
        }
        return [];
    };
    // manage cd's should show for users with active (not closed CD accounts) that are NOT IRA cd's
    var getManageCDs = function () {
        if (hasOpenDepositAccounts) {
            return hasCDAnonIRA ? [getManageCDsItem(isCdIraHiddenInMobile)] : [];
        }
        return [];
    };
    // manage IRA's should only show for open IRA accounts
    var getManageIRAs = function () {
        if (hasOpenDepositAccounts) {
            return hasIRA ? [getManageIRAsItem(isCdIraHiddenInMobile)] : [];
        }
        return [];
    };
    var getDocuments = function () {
        // bank documents should still be shown for accounts closed within 60 days but not on mobile
        var items = [];
        if (isAutoEnabled) {
            items = hasAutoAccounts
                ? [
                    {
                        name: 'bank',
                        visible: hasActiveDepositAccounts,
                        items: bankStatements,
                    },
                    {
                        name: 'bank',
                        visible: hasActiveDepositAccounts,
                        items: bankTaxForms,
                    },
                    {
                        name: 'invest',
                        visible: hasInvestAccounts,
                        items: investDocuments,
                    },
                    {
                        name: 'cc',
                        visible: showCreditCard,
                        items: ccStatements,
                    },
                    {
                        name: 'vehicle',
                        visible: showAuto,
                        items: vehicleDocuments(firstAutoAccount.id),
                    },
                    {
                        name: 'mortgage',
                        visible: showMortgageLink,
                        items: homeLoansStatementsButton(redirectToMortgage),
                    },
                ]
                : [
                    {
                        name: 'bank',
                        visible: hasActiveDepositAccounts,
                        items: bankStatements,
                    },
                    {
                        name: 'bank',
                        visible: hasActiveDepositAccounts,
                        items: bankTaxForms,
                    },
                    {
                        name: 'invest',
                        visible: hasInvestAccounts,
                        items: investDocuments,
                    },
                    {
                        name: 'cc',
                        visible: showCreditCard,
                        items: ccStatements,
                    },
                    {
                        name: 'mortgage',
                        visible: showMortgageLink,
                        items: homeLoansStatementsButton(redirectToMortgage),
                    },
                ];
        }
        else {
            items = [
                {
                    name: 'bank',
                    visible: hasActiveDepositAccounts,
                    items: bankDocuments,
                },
                {
                    name: 'invest',
                    visible: hasInvestAccounts,
                    items: investStatements,
                },
                {
                    name: 'cc',
                    visible: showCreditCard,
                    items: ccStatements,
                },
                {
                    name: 'mortgage',
                    visible: showMortgageLink,
                    items: homeLoansStatementsButton(redirectToMortgage),
                },
            ];
        }
        var shownItems = items.filter(function (obj) { return obj.visible; }).map(function (obj) { return obj.items; });
        if (shownItems.length === 0) {
            return [];
        }
        return [
            isAutoEnabled
                ? documentDropdown(shownItems)
                : statementDropdown(shownItems),
        ];
    };
    var getTaxForms = function () {
        if (taxFormsEnabled && hasBankOrInvestAccounts) {
            if (isInvestNotBank) {
                return [__assign(__assign({}, taxForms), { url: investDocuments.url })];
            }
            return [taxForms];
        }
        return [];
    };
    return {
        isBankDown: isBankDown,
        isInvestDown: isInvestDown,
        isWealthDown: isWealthDown,
        getTransfers: getTransfers,
        getPayments: getPayments,
        getWealthOverview: getWealthOverview,
        getInvestments: getInvestments,
        getDeposits: getDeposits,
        getManageCDs: getManageCDs,
        getManageIRAs: getManageIRAs,
        getDocuments: getDocuments,
        getTaxForms: getTaxForms,
    };
};
//# sourceMappingURL=useSchemaItems.js.map